import React from 'react';

const TONES = {
  gray: 'bg-gray-100 text-gray-700',
  blue: 'bg-primary-100 text-primary-700',
  green: 'bg-emerald-100 text-emerald-700',
  yellow: 'bg-amber-100 text-amber-700',
  red: 'bg-red-100 text-red-700',
  purple: 'bg-purple-100 text-purple-700',
};

// Common backend status strings mapped to a sensible tone by default.
const STATUS_TONE = {
  active: 'green',
  approved: 'green',
  completed: 'green',
  pending: 'yellow',
  suspended: 'red',
  rejected: 'red',
  dismissed: 'gray',
  cancelled: 'gray',
  expired: 'gray',
  reviewed: 'blue',
  actioned: 'purple',
};

export default function Badge({ tone, status, children, className = '' }) {
  const resolvedTone = tone || STATUS_TONE[String(status).toLowerCase()] || 'gray';
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${TONES[resolvedTone]} ${className}`}
    >
      {children ?? status}
    </span>
  );
}
